import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useNotification } from '../../context/NotificationContext'
import { useLoggedInUser } from '../../context/LoggedUser'


const GenerateSalarySlip = () => {
  const [formData, setFormData] = useState({
    employeeId:"",
    employeeName: "",
    bankName: "",
    bankAccountHolder: "",
    bankAccountNumber: "",
    ifscCode: "",
    daysOfWorking: 0,
    perDaySalary: 0,
    // role: "",
    incentive: 0,
    deduction:0,
    month:"",
  });
  
  const apiUrl = process.env.REACT_APP_API_URL;
  const [employeeData, setEmployeeData] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState();
  const [salarySlipData, setsalarySlipData] = useState();
  const {createNotification} = useNotification()
  const { loggedInUser } = useLoggedInUser()
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  

  useEffect(() => {
  const fetchEmployees = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/api/employees/get-all-employees`,
        { withCredentials: true }
      );
      setEmployeeData(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };
   fetchEmployees()
}, []);
  
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1; 
    const daysInMonth = new Date(currentYear, currentMonth, 0).getDate();
    // console.log("Selected Emp",selectedEmployee)

    let perDaySalary = Math.ceil(selectedEmployee?.salary/daysInMonth)

      setFormData({
        employeeId:selectedEmployee?._id || "",
        employeeName: selectedEmployee?.name || "",
        bankName: selectedEmployee?.bankDetails?.bankName || "",
        bankAccountHolder: selectedEmployee?.bankDetails?.bankAccountHolder || "",
        bankAccountNumber: selectedEmployee?.bankDetails?.bankAccountNumber || "",
        ifscCode: selectedEmployee?.bankDetails?.ifscCode || "",
        perDaySalary: perDaySalary || "",
        org_id: selectedEmployee?.org_id || "",
      });
  }, [selectedEmployee]);
  

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Fields that should only allow numbers
    const isNumberField = ["perDaySalary", "daysOfWorking", "incentive", "deduction"];
    
    // Prevent non-numeric values
    if (isNumberField.includes(name) && !/^\d*$/.test(value)) {
        return;
    }

    // Check if daysOfWorking is greater than or equal to 30
    if (name === "daysOfWorking" && Number(value) >= 30) {
        toast.error("Days of working should be less than 30");
        return;
    }

    setFormData({ ...formData, [name]: value });
};


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
        // const { employeeName, ...dataToSend } = formData;
        // const response = await axios.post(`${apiUrl}/api/hr/createPaySlip`, dataToSend, { withCredentials: true });
        const {
  employeeName,
  bankName,
  bankAccountHolder,
  bankAccountNumber,
  ifscCode,
  ...rest
} = formData;

const dataToSend = {
  ...rest,
  bankDetails: {
    bankName,
    bankAccountHolder,
    bankAccountNumber,
    ifscCode,
  },
  org_id: formData.org_id, 
};

const response = await axios.post(`${apiUrl}/api/hr/createPaySlip`, dataToSend, { withCredentials: true });
      if(response.status === 201){
        setsalarySlipData(response.data.data)
        setFormData({ employeeName: "", month:"", employeeId:"", bankName: "", bankAccountHolder: "", bankAccountNumber: "", ifscCode: "", daysOfWorking: "", perDaySalary: "", incentive: "" });

        //socket for realtime notification
        createNotification({
          sender: loggedInUser._id,
          receiver: [response.data.data.employeeId],
          message: "You Salary Slip Generated",
          // notDesc:
        });
      }
      

    } catch (error) {
      toast.error("Failed to generate salary slip.");
    }
  };

  useEffect(() => {
    if (salarySlipData) {
      generatePDF();
    }
  }, [salarySlipData]);
  
  
  
  const generatePDF = () => {
  const doc = new jsPDF();

  const logoUrl = `${window.location.origin}/images/logo.png`;
  const imgWidth = 40;
  const imgHeight = 20;
  const imgX = 150;
  const imgY = 10;

  doc.addImage(logoUrl, "PNG", imgX, imgY, imgWidth, imgHeight);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Pay Slip", 90, 15);

  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");

  const generalDetails = [
    { title: "Employee Name", value: salarySlipData.employeeName || formData.employeeName },
    { title: "Bank Name", value: salarySlipData.bankDetails?.bankName || "N/A" },
    { title: "Bank Account Holder", value: salarySlipData.bankDetails?.bankAccountHolder || "N/A" },
    { title: "Bank Account Number", value: salarySlipData.bankDetails?.bankAccountNumber || "N/A" },
    { title: "IFSC Code", value: salarySlipData.bankDetails?.ifscCode || "N/A" },
    { title: "Month", value: salarySlipData.month || "N/A" },
  ];

  let y = 30;
  generalDetails.forEach((detail) => {
    doc.text(`${detail.title}: ${detail.value}`, 20, y);
    y += 10;
  });

  const salaryDetails = [
    ["Days of Working", salarySlipData.daysOfWorking || "N/A"],
    ["Per Day Salary", salarySlipData.perDaySalary || "N/A"],
    ["Incentive", salarySlipData.incentive || "N/A"],
    ["Deduction", salarySlipData.deduction || "N/A"],
    ["Total Salary(Rs)", salarySlipData.totalSalary || "N/A"],
  ];

  y += 10;

  doc.autoTable({
    startY: y,
    head: [["Field", "Details"]],
    body: salaryDetails,
    theme: "grid",
    styles: {
      font: "helvetica",
      fontSize: 12,
      cellPadding: 4,
    },
    headStyles: {
      fillColor: [0, 102, 204],
      textColor: [255, 255, 255],
      fontSize: 13,
      fontStyle: "bold",
    },
    alternateRowStyles: {
      fillColor: [240, 240, 240],
    },
    margin: { top: 25 },
  });

  doc.save("Pay_Slip.pdf");
  toast.success("Salary Slip generated successfully!");
};

  return (
    <div className="rounded-lg w-auto h-full p-10 m-6">
      <h2 className="text-2xl font-bold pb-12">
        Generate Pay Slip
      </h2>
      <form onSubmit={handleSubmit}>
        <p className="p-2 text-lg font-medium">Select an Employee</p>
        <select
          name="employeeId"
          value={formData.employeeId}
          onChange={(e) => {
            const selectedEmployee = employeeData.find(emp => emp._id === e.target.value);
            setSelectedEmployee(selectedEmployee);
            handleChange(e); 
          }}
          className="w-full p-4 border rounded-lg mb-2"
          required
        >
          <option value="" disabled>Select Employee</option>
          {employeeData.map((employee, index) => (
            <option key={index} value={employee._id}>
              {employee.name}
            </option>
          ))}
        </select>

        <p className="p-2 text-lg font-medium">Bank Name</p>
        <input
          type="text"
          name="bankName"
          placeholder="Enter Bank Name"
          value={formData.bankName}
          onChange={handleChange}
          className="w-full p-4 border rounded-lg mb-2"
        
        />
        <p className="p-2 text-lg font-medium">Bank Account Holder</p>
        <input
          type="text"
          name="bankAccountHolder"
          placeholder="Enter bank Holder"
          value={formData.bankAccountHolder}
          onChange={handleChange}
          className="w-full p-4 border rounded-lg mb-2"
         
        />
        <p className="p-2 text-lg font-medium">Bank Account Number</p>
        <input
          type="text"
          name="bankAccountNumber"
          placeholder="Enter Bank Account Number"
          value={formData.bankAccountNumber}
          onChange={handleChange}
          className="w-full p-4 border rounded-lg mb-2"
       
        />
        <p className="p-2 text-lg font-medium">IFSC Code</p>
        <input
          type="text"
          name="ifscCode"
          placeholder="Enter IFSC Code"
          value={formData.ifscCode}
          onChange={handleChange}
          className="w-full p-4 border rounded-lg mb-2"
         
        />
        <p className="p-2 text-lg font-medium">Days of Working</p>
        <input
          type="number"
          name="daysOfWorking"
          placeholder="Enter days of working"
          value={formData.daysOfWorking}
          onChange={handleChange}
          className="w-full p-4 border rounded-lg mb-2"
          required
        />
        <p className="p-2 text-lg font-medium">Month</p>
          <select
            name="month"
            value={formData.month}
            onChange={handleChange}
            className="w-full p-4 border rounded-lg mb-2"
            required
          >
            <option value="" disabled>Select a month</option>
            {months.map((month, index) => (
              <option key={index} value={month}>{month}</option>
            ))}
          </select>
        <p className="p-2 text-lg font-medium">Per Day Salary</p>
        <input
  type="number"
  name="perDaySalary"
  value={formData.perDaySalary}
  className="w-full p-4 border rounded-lg mb-2 bg-gray-100 cursor-not-allowed"
  readOnly
/>
        <p className="p-2 text-lg font-medium">Incentive</p>
        <input
          type="number"
          name="incentive"
          placeholder="Enter Incentive"
          value={formData.incentive}
          onChange={handleChange}
          className="w-full p-4 border rounded-lg mb-2"
        />
        <p className="p-2 text-lg font-medium">Deduction</p>
        <input
          type="number"
          name="deduction"
          placeholder="Enter Deduction"
          value={formData.deduction}
          onChange={handleChange}
          className="w-full p-4 border rounded-lg mb-2"
        />
        <div className="flex justify-start space-x-2 mt-4 gap-2 py-5">
        <button type="submit" className="bg-blue-500 p-2 px-5 text-white text-xl rounded-lg">
         Generate
        </button>
        </div>
      </form>
    </div>
  );
};

export default GenerateSalarySlip;
